import { Box, Grid, styled, Typography } from "@mui/material";
import { ProductDto } from "../../services/generated.schemas";
import { useNavigate } from "react-router-dom";

type ProductsGridType = {
  collectionId: string | undefined;
  products: ProductDto[] | undefined;
};

const ProductItem = styled(Grid)({
  cursor: "pointer",
});

const ProductImage = styled("img")({
  width: "100%",
  height: "auto",
  display: "block",
});

const ProductTitle = styled(Typography)({
  fontFamily: "Geist, sans-serif",
  color: "black",
  marginTop: "clamp(0.5rem, 1vw, 1rem)",
  fontSize: "clamp(0.6rem, 1.5vw, 1.1rem)",
});

const ProductsGrid = ({ collectionId, products }: ProductsGridType) => {
  const navigate = useNavigate();

  return (
    <Grid
      container
      spacing={5}
      padding={"2rem"}
      columns={{ xs: 4, sm: 8, md: 12 }}
    >
      {products?.map((product) => (
        <ProductItem
          key={product.id}
          size={{ xs: 2, sm: 4, md: 4 }}
          onClick={() => navigate(`/singleItem/${collectionId}/${product.id}`)}
        >
          <Box
            sx={{
              width: "20vw",
              backgroundColor: "#F3F3F3",
              padding: 5,
            }}
          >
            <ProductImage src={product.image} />
          </Box>
          <ProductTitle variant="h6">{product.title}</ProductTitle>
        </ProductItem>
      ))}
    </Grid>
  );
};

export default ProductsGrid;
